import React, { useCallback, useEffect, useState } from 'react';
import { filter } from 'rxjs/operators';
import { container } from 'tsyringe';
import { ErrorService, StudioError } from '../../services/error-service';
import { SoundKey, SoundService } from '../../services/sound-service';
import DestinationErrorDialog from '../layout/errorDialogs/DestinationErrorDialog';
import FatalErrorDialog from '../layout/errorDialogs/FatalErrorDialog';
import NetworkErrorDialog from '../layout/errorDialogs/NetworkErrorDialog';
import PoorNetworkWarningDialog from '../layout/errorDialogs/PoorNetworkWarningDialog';
import UnknownErrorDialog from '../layout/errorDialogs/UnknownErrorDialog';


const ErrorHandlers = ({ globalError }: { globalError: boolean }) => {

    const [soundService] = useState(container.resolve(SoundService));

    const [errorService] = useState(container.resolve(ErrorService));
    const [error, setError] = useState('' as 'unknown' | 'network' | 'poor_network' | 'destination' | 'fatal' | '');
    const [messageError, setMessageError] = useState<StudioError>(null);

    const handleDisconnected = useCallback(() => {
        soundService.playSoundStart(SoundKey.Error);
        setError('network');
    }, [setError]);

    const handleReconnected = useCallback(() => {
        setError('');
    }, [setError]);

    useEffect(() => {
        if (globalError) {
            soundService.playSoundStart(SoundKey.Error);
            setError('unknown');
        }
    }, [globalError]);

    const clearError = () => {
        setError('');
        setMessageError(null);
    };

    useEffect(() => {
        window.addEventListener('offline', handleDisconnected);
        window.addEventListener('online', handleReconnected);
        const sub = errorService.errorObservable.pipe(filter(e => !!e)).subscribe(e => {
            soundService.playSoundStart(SoundKey.Error);
            setMessageError(e);
            setError(e.type);
        });

        return () => {
            window.removeEventListener('offline', handleDisconnected);
            window.removeEventListener('online', handleReconnected);
            sub.unsubscribe();
        };
    }, []);

    return <>
        <UnknownErrorDialog open={error === 'unknown'} details={messageError?.message} close={() => clearError()}></UnknownErrorDialog>
        <NetworkErrorDialog open={error === 'network'}></NetworkErrorDialog>
        <PoorNetworkWarningDialog open={error === 'poor_network'}></PoorNetworkWarningDialog>
        <DestinationErrorDialog open={error === 'destination'}></DestinationErrorDialog>
        <FatalErrorDialog open={error === 'fatal'} error={messageError}></FatalErrorDialog>
    </>
}

export default ErrorHandlers;
